import { EditIcon } from '@mm/icons';
import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormFieldWrapper from '../../../../../../../common/components/FormFieldWrapper/FormFieldWrapper';
import TextInput from '../../../../../../../common/components/TextInput';
import { ENTER_KEY_NAME } from '@mm/constants/keys-codes';
import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import { selectAudienceByIdOrIds } from '@mm/state/selectors/messengerAdSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { Heading } from '@mm/components';
import './AudienceNameInput.pcss';

type Props = {
  audienceId: number;
  setNameChanged: (changes: boolean) => void;
  className?: string;
  usedInActiveDrip?: boolean;
};

export const AudienceNameInput = ({
  className,
  audienceId,
  setNameChanged,
  usedInActiveDrip,
}: Props) => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);
  const { update: updateAudience } = useAudiencesCRUDActions();
  const [audience] = useSelector((state: StoreState) =>
    selectAudienceByIdOrIds(state, audienceId),
  );
  const [isEditMode, setIsEditMode] = useState(false);
  const [name, setName] = useState(audience?.name || '');

  useEffect(() => {
    if (audience) {
      setName(audience.name);
    }
  }, [audience]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setName(e.target.value);
  const onBlur = () => {
    if (!name) {
      setName(audience?.name);
    }

    if (name && audience?.name !== name) {
      updateAudience({ name }, activeChatbotId);
      setNameChanged(true);
    }
    setIsEditMode(false);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === ENTER_KEY_NAME) {
      onBlur();
    }
  };

  const error = !name && 'Please fill audience name';

  return (
    <div className={classNames(className, 'audience-name-input')}>
      {isEditMode && (
        <FormFieldWrapper
          className={classNames(className, 'audience-name-input__form-field')}
          error={error}
        >
          <TextInput
            placeholder="Audience name"
            className="audience-name-input__form-input"
            onChange={onChange}
            onBlur={onBlur}
            value={name}
            onKeyDown={onKeyDown}
          />
        </FormFieldWrapper>
      )}
      {!isEditMode && <Heading text={name} size={3} />}
      {!usedInActiveDrip && (
        <EditIcon
          className="audience-name-input__edit-icon"
          onClick={() => setIsEditMode(true)}
        />
      )}
    </div>
  );
};
